//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OrderDetail from './OrderDetail.vue';
import OrderStatus from './OrderStatus.vue';

export default {
  components: {
    OrderDetail,
    OrderStatus,
  },
  props: {
    orders: {
      type: Array,
      default: () => [],
    },
    detailId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      formatters: {
        CZK: new Intl.NumberFormat('cs-CZ', {
          style: 'currency',
          currency: 'CZK',
        }),
        EUR: new Intl.NumberFormat('cs-CZ', {
          style: 'currency',
          currency: 'EUR',
        }),
      },
      selectedOrder: null,
      localOrders: this.orders,
    };
  },
  mounted() {
    if (this.detailId) {
      this.selectedOrder = this.orders.find(o => o.id === this.detailId);
    }
  },
  methods: {
    formatDate(date) {
      const d = new Date(date);
      const day = d.getDate();
      const month = d.getMonth() + 1;
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },
    products(lineItems) {
      return lineItems.map(item => item.name).join(', ');
    },
    total(total, currency) {
      return this.formatters[currency].format(total);
    },
    updateOrder(order) {
      const index = this.localOrders.findIndex(o => o.id === order.id);
      if (index !== -1) {
        const { update } = order;
        Object.keys(update).forEach(key => {
          this.localOrders[index][key] = update[key];
        });
      }
    },
    close() {
      this.selectedOrder = null;
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/auth/partials/OrdersTable.vue